import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Alarm',
      href: '/de/720p_Series_CGI_List/Alarm_Menu/',
    },
    {
      text: 'Multimedia',
      href: '/de/720p_Series_CGI_List/Multimedia_Menu/',
    },
    {
      text: 'Netzwerk',
      href: '/de/720p_Series_CGI_List/Netzwerk_Menu/',
    },
    {
      text: 'Software',
      href: '/de/720p_Series_CGI_List/Software_Menu/',
    },
    {
      text: 'System',
      href: '/de/720p_Series_CGI_List/System_Menu/',
    },
    {
      text: 'Vollständige Liste',
      href: '/de/720p_Series_CGI_List/Komplette_CGI_Liste/',
    },
    {
      text: '720p CGIs',
      href: '/de/720p_Series_CGI_List/',
    },
    {
      text: 'CGIs Befehle',
      href: '/de/Erweitert/CGI_Befehle/',
    },
    {
      text: '◄ Entwickler',
      href: '/de/Erweitert/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Topics for Developers"
      />
      <EuiSpacer />
    </Fragment>
  );
}